package com.tixforgigs.common.core.util

import com.tixforgigs.apax.models.AuthToken
import com.tixforgigs.common.core.extensions.orElse
import com.tixforgigs.common.core.extensions.tryCatchSentry
import com.tixforgigs.common.core.models.embed.PostMessageEmbedAuthDTO
import com.tixforgigs.common.core.models.embed.PostMessageEmbedHeightDTO
import com.tixforgigs.common.core.models.embed.PostMessageEmbedOriginDTO
import com.tixforgigs.common.core.models.embed.PostMessageHandshakeDTO
import com.tixforgigs.common.core.util.StorageUtil.deleteLocalStorageItem
import com.tixforgigs.common.core.util.StorageUtil.setLocalStorageItem
import js.array.ReadonlyArray
import kotlinx.browser.window
import kotlinx.serialization.json.Json
import org.w3c.dom.MessageEvent
import web.dom.document
import web.resize.ResizeObserver
import web.resize.ResizeObserverEntry

actual object EmbedUtil {
  actual fun init() {
    val body = document.body

    window.onload = {
      postToParentPage(PostMessageHandshakeDTO())
    }

    val resize = ResizeObserver { entries, _ ->
      sendIframeHeight(entries = entries)
    }
    resize.observe(body)

    window.addEventListener("message", { event ->
      runCatching { event.unsafeCast<MessageEvent>() }.getOrNull()?.let { messageEvent ->
        runCatching {
          Json.decodeFromString<PostMessageEmbedOriginDTO>(messageEvent.data.toString())
        }.getOrNull()?.let { originMessage ->
          document.documentElement.dataset["embed"] = true.toString()
          document.documentElement.dataset["origin"] = originMessage.origin
        }

        runCatching {
          Json.decodeFromString<PostMessageEmbedAuthDTO>(messageEvent.data.toString())
        }.getOrNull()?.let { authMessage ->
          authMessage.authToken?.let { authToken ->
            setLocalStorageItem<AuthToken>(
              key = StorageUtil.StorageKey.AuthToken,
              item = authToken,
              serializer = AuthToken.serializer()
            )
          }
          authMessage.internalRedirectPath?.let { path ->
            deleteLocalStorageItem(StorageUtil.StorageKey.LoginStartLocation)
            window.location.pathname = path
          }
        }
      }
    })
  }

  actual inline fun <reified T> postToParentPage(value: T) {
    window.parent.postMessage(
      message = Json.encodeToString(value),
      targetOrigin = document.documentElement.dataset["origin"].orElse { "*" }
    )
  }

  private fun sendIframeHeight(entries: ReadonlyArray<ResizeObserverEntry>) {
    entries.let { entries ->
      entries.forEach { entry ->
        tryCatchSentry { entry.contentRect.height.toInt() }
          .onSuccess { height ->
            postToParentPage(
              value = PostMessageEmbedHeightDTO(
                height = height
              )
            )
          }
      }
    }
  }
}